export const FETCH_AVERAGE_TICKET = "dashboard/FETCH_AVERAGE_TICKET";
export const FETCH_AVERAGE_TICKET_SUCCESS = "dashboard/FETCH_AVERAGE_TICKET_SUCCESS";
export const FETCH_AVERAGE_TICKET_FAILURE = "dashboard/FETCH_AVERAGE_TICKET_FAILURE";
export const RESET_AVERAGE_TICKET = "dashboard/RESET_AVERAGE_TICKET";

export const FETCH_TOP_CUSTOMERS = "dashboard/FETCH_TOP_CUSTOMERS";
export const FETCH_TOP_CUSTOMERS_SUCCESS = "dashboard/FETCH_TOP_CUSTOMERS_SUCCESS";
export const FETCH_TOP_CUSTOMERS_FAILURE = "dashboard/FETCH_TOP_CUSTOMERS_FAILURE";
export const RESET_TOP_CUSTOMERS = "dashboard/RESET_TOP_CUSTOMERS";

export const FETCH_SELLS_BY_DAY = "dashboard/FETCH_SELLS_BY_DAY";
export const FETCH_SELLS_BY_DAY_SUCCESS = "dashboard/FETCH_SELLS_BY_DAY_SUCCESS";
export const FETCH_SELLS_BY_DAY_FAILURE = "dashboard/FETCH_SELLS_BY_DAY_FAILURE";
export const RESET_SELLS_BY_DAY = "dashboard/RESET_SELLS_BY_DAY";

export const FETCH_SELLS_BY_HOUR = "dashboard/FETCH_SELLS_BY_HOUR";
export const FETCH_SELLS_BY_HOUR_SUCCESS = "dashboard/FETCH_SELLS_BY_HOUR_SUCCESS";
export const FETCH_SELLS_BY_HOUR_FAILURE = "dashboard/FETCH_SELLS_BY_HOUR_FAILURE";
export const RESET_SELLS_BY_HOUR = "dashboard/RESET_SELLS_BY_HOUR";

export const FETCH_SELLS_BY_MONTH = "dashboard/FETCH_SELLS_BY_MONTH";
export const FETCH_SELLS_BY_MONTH_SUCCESS = "dashboard/FETCH_SELLS_BY_MONTH_SUCCESS";
export const FETCH_SELLS_BY_MONTH_FAILURE = "dashboard/FETCH_SELLS_BY_MONTH_FAILURE";
export const RESET_SELLS_BY_MONTH = "dashboard/RESET_SELLS_BY_MONTH";

export const FETCH_SELLS_TOP_EMPLOYEES = "dashboard/FETCH_SELLS_TOP_EMPLOYEES";
export const FETCH_SELLS_TOP_EMPLOYEES_SUCCESS = "dashboard/FETCH_SELLS_TOP_EMPLOYEES_SUCCESS";
export const FETCH_SELLS_TOP_EMPLOYEES_FAILURE = "dashboard/FETCH_SELLS_TOP_EMPLOYEES_FAILURE";
export const RESET_SELLS_TOP_EMPLOYEES = "dashboard/RESET_SELLS_TOP_EMPLOYEES";

export const FETCH_SELLS_TOP_CATEGORIES = "dashboard/FETCH_SELLS_TOP_CATEGORIES";
export const FETCH_SELLS_TOP_CATEGORIES_SUCCESS = "dashboard/FETCH_SELLS_TOP_CATEGORIES_SUCCESS";
export const FETCH_SELLS_TOP_CATEGORIES_FAILURE = "dashboard/FETCH_SELLS_TOP_CATEGORIES_FAILURE";
export const RESET_SELLS_TOP_CATEGORIES = "dashboard/RESET_SELLS_TOP_CATEGORIES";

export const FETCH_STORE_VISITORS = "dashboard/FETCH_STORE_VISITORS";
export const FETCH_STORE_VISITORS_SUCCESS = "dashboard/FETCH_STORE_VISITORS_SUCCESS";
export const FETCH_STORE_VISITORS_FAILURE = "dashboard/FETCH_STORE_VISITORS_FAILURE";
export const RESET_STORE_VISITORS = "dashboard/RESET_STORE_VISITORS";

export const FETCH_NEW_CLIENTS = "dashboard/FETCH_NEW_CLIENTS";
export const FETCH_NEW_CLIENTS_SUCCESS = "dashboard/FETCH_NEW_CLIENTS_SUCCESS";
export const FETCH_NEW_CLIENTS_FAILURE = "dashboard/FETCH_NEW_CLIENTS_FAILURE";
export const RESET_NEW_CLIENTS = "dashboard/RESET_NEW_CLIENTS";

export const FETCH_FRANCHISE_REPORT = "dashboard/FETCH_FRANCHISE_REPORT";
export const FETCH_FRANCHISE_REPORT_SUCCESS = "dashboard/FETCH_FRANCHISE_REPORT_SUCCESS";
export const FETCH_FRANCHISE_REPORT_FAILURE = "dashboard/FETCH_FRANCHISE_REPORT_FAILURE";
export const RESET_FRANCHISE_REPORT = "dashboard/RESET_FRANCHISE_REPORT";



// WEBPACK FOOTER //
// ./src/store/dashboard/actionTypes.js